var _g, _g2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeviceApOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_960_10497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1667 14H26.8333C19.7457 14 14 19.7457 14 26.8333V43.1667C14 50.2543 19.7457 56 26.8333 56H43.1667C50.2543 56 56 50.2543 56 43.1667V26.8333C56 19.7457 50.2543 14 43.1667 14Z",
    fill: "#F7F7F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_960_10497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3656 32.6782C45.6998 33.3486 45.0236 34.0155 44.3371 34.6998C41.8048 32.2057 38.7448 30.9031 35.1845 30.9031C31.6311 30.9031 28.5676 32.1814 25.9906 34.7346C25.3248 34.0502 24.6658 33.3729 24 32.6955C30.0718 26.4013 40.3283 26.4742 46.3656 32.6782Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9841 36.7737C32.0511 32.6506 38.6119 32.8859 42.3509 36.7701C42.316 36.8053 42.2916 36.8509 42.2533 36.8896C41.6429 37.5041 41.0325 38.1187 40.436 38.7404C40.3454 38.8317 40.293 38.8211 40.2128 38.7404C39.2188 37.7394 38.0224 37.1108 36.6482 36.8439C35.7413 36.6683 34.8309 36.6578 33.9206 36.8088C32.6335 37.023 31.4965 37.5568 30.5024 38.3962C30.3385 38.5332 30.1885 38.6912 30.0595 38.8071C29.3619 38.1187 28.6782 37.4515 27.9911 36.7737H27.9841Z",
    fill: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1355 44.0002C34.6447 43.506 34.1644 43.0082 33.6805 42.514C33.1792 42.0092 32.6848 41.5044 32.18 41.0031C32.0783 40.9007 32.0643 40.8372 32.18 40.7348C33.8453 39.1992 36.4362 39.1957 38.0945 40.7172C38.2172 40.8266 38.2313 40.8831 38.1015 41.0137C37.1339 41.988 36.1768 42.9658 35.2126 43.9437C35.2021 43.9543 35.1846 43.9649 35.139 43.9966L35.1355 44.0002Z",
    fill: "#D1D1D1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 13,
    r: 5,
    fill: "#DB0046"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_960_10497",
    x: 13.5,
    y: 13,
    width: 42.5,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.5,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_960_10497"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_960_10497",
    x: 24,
    y: 28,
    width: 22.3655,
    height: 16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.723437 0 0 0 0 0.723437 0 0 0 0 0.723437 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_960_10497"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeviceApOff);
export default __webpack_public_path__ + "static/media/img_device_ap_off.52f6855bd6e7e7933f526844c4a7cce6.svg";
export { ForwardRef as ReactComponent };